import React, { useState } from 'react';
import '../App.css';
import './Skills.css';

const Skills = () => {
  const [expandedCategories, setExpandedCategories] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const skills = {
    dataAnalyticsBI: [
      { name: 'Microsoft Power BI', source: 'Enterprise Dashboards & DAX', level: 95, icon: 'fas fa-chart-pie' },
      { name: 'Tableau', source: 'Deloitte Simulation / Unified Mentor', level: 92, icon: 'fas fa-chart-bar' },
      { name: 'Data Visualization & Storytelling', source: 'Accenture / Tata / Quantium', level: 95, icon: 'fas fa-eye' },
      { name: 'Google Analytics', source: 'Google Certified', level: 90, icon: 'fab fa-google' },
      { name: 'Microsoft Excel (Power Query, Pivot)', source: 'Goldman Sachs Simulation', level: 92, icon: 'fas fa-file-excel' },
      { name: 'Data Modeling & Schemas', source: 'Accenture North America', level: 88, icon: 'fas fa-cube' },
      { name: 'Data Interpretation & Reporting', source: 'Accenture / Tata', level: 90, icon: 'fas fa-search' },
      { name: 'Executive KPI Architecture', source: 'Industry Simulations', level: 88, icon: 'fas fa-tachometer-alt' }
    ],
    databaseSQL: [
      { name: 'SQL (Complex Joins & Aggregations)', source: 'Walmart USA Simulation', level: 90, icon: 'fas fa-database' },
      { name: 'Relational Database Design', source: 'Walmart USA Simulation', level: 85, icon: 'fas fa-project-diagram' },
      { name: 'Data Wrangling & Cleaning', source: 'Quantium / Tata Group', level: 92, icon: 'fas fa-filter' },
      { name: 'Data Validation & Integrity', source: 'Quantium Simulation', level: 88, icon: 'fas fa-check-double' },
      { name: 'Data Munging & Transformation', source: 'Walmart USA Simulation', level: 85, icon: 'fas fa-tools' },
      { name: 'ETL Pipeline Logic', source: 'Yellow.ai / Enterprise Data', level: 85, icon: 'fas fa-stream' }
    ],
    mlAi: [
      { name: 'Python (Pandas, NumPy, Matplotlib)', source: 'Data Analytics Stack', level: 90, icon: 'fab fa-python' },
      { name: 'Predictive Modeling & Scikit-Learn', source: 'Predictive Analytics Projects', level: 85, icon: 'fas fa-brain' },
      { name: 'Statistical Testing & Regression', source: 'Quantium Simulation', level: 88, icon: 'fas fa-calculator' },
      { name: 'Machine Learning Algorithms', source: 'GrowthLink ML Intern', level: 85, icon: 'fas fa-network-wired' },
      { name: 'Pattern Recognition & Clustering', source: 'Retail Basket Analysis', level: 82, icon: 'fas fa-puzzle-piece' },
      { name: 'AI-Driven Analytics & LLM Flows', source: 'Yellow.ai / Google', level: 82, icon: 'fas fa-robot' }
    ],
    analyticalBusiness: [
      { name: 'Commercial & Market Thinking', source: 'Quantium Simulation', level: 88, icon: 'fas fa-lightbulb' },
      { name: 'Financial & Investment Analysis', source: 'Bluestock / FDI Analysis', level: 85, icon: 'fas fa-dollar-sign' },
      { name: 'Market Basket Analysis (Apriori)', source: 'Retail Transaction Study', level: 88, icon: 'fas fa-shopping-cart' },
      { name: 'Quantitative Problem Solving', source: 'Quantium Simulation', level: 85, icon: 'fas fa-balance-scale' },
      { name: 'Scenario Planning & Assumptions', source: 'Goldman Sachs Simulation', level: 82, icon: 'fas fa-tasks' },
      { name: 'Executive Insights Delivery', source: 'Accenture / Tata', level: 92, icon: 'fas fa-chalkboard-teacher' }
    ],
    technicalProgramming: [
      { name: 'Python Programming', source: 'Core Development', level: 88, icon: 'fab fa-python' },
      { name: 'JSON & API Data Flows', source: 'Yellow.ai Intern', level: 90, icon: 'fas fa-code-branch' },
      { name: 'HTML & CSS (Dashboard Embedding)', source: 'Unnati Informatics', level: 90, icon: 'fab fa-html5' },
      { name: 'Software Development Foundations', source: 'Bluestock Intern', level: 82, icon: 'fas fa-laptop-code' },
      { name: 'Git & Version Control', source: 'GitHub Repositories', level: 85, icon: 'fab fa-git-alt' }
    ],
    softSkillsManagement: [
      { name: 'Data Presentation & Storytelling', source: 'Quantium Simulation', level: 92, icon: 'fas fa-presentation' },
      { name: 'Stakeholder Communication', source: 'Career Development Cell', level: 90, icon: 'fas fa-comments' },
      { name: 'Project Coordination & Management', source: 'CDC Student Coordinator', level: 88, icon: 'fas fa-users-cog' },
      { name: 'Critical Analytical Thinking', source: 'Competitive Sports & Studies', level: 92, icon: 'fas fa-crosshairs' }
    ]
  };

  const renderSkillList = (skillList, category) => {
    if (!skillList) return null;
    
    const filteredSkills = searchTerm 
      ? skillList.filter(skill => 
          skill.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
          skill.source.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : skillList;

    if (filteredSkills.length === 0) return null;

    const isExpanded = expandedCategories[category];
    const displaySkills = isExpanded ? filteredSkills : filteredSkills.slice(0, 5);
    const hasMoreSkills = filteredSkills.length > 5;

    return (
      <>
        <ul className="skill-list">
          {displaySkills.map((skill, index) => (
            <li key={`${category}-${index}`} className="skill-item">
              <div className="skill-main">
                <i className={skill.icon}></i>
                <div className="skill-info">
                  <span className="skill-name">{skill.name}</span>
                  <span className="skill-source">{skill.source}</span>
                </div>
              </div>
              <div className="skill-level">
                <div className="skill-level-bar" style={{ width: `${skill.level}%` }}></div>
                <span className="skill-level-num">{skill.level}%</span>
              </div>
            </li>
          ))}
        </ul>
        {hasMoreSkills && (
          <button 
            className="show-more-btn"
            onClick={() => toggleCategory(category)}
          >
            {isExpanded ? 'Show Less' : `+ Show ${filteredSkills.length - 5} More`}
          </button>
        )}
      </>
    );
  };

  return (
    <div className="skills-container">
      <div className="skills-content-box">
        <div className="skills-header-section">
          <span className="section-badge"><i className="fas fa-layer-group"></i> Technical Competencies</span>
          <h1>Data & Analytics Capabilities</h1>
          <p className="skills-subtitle">
            An overview of technical tools, querying languages, BI suites, and analytical methodologies I leverage to extract insights from raw data.
          </p>
        </div>
        
        <div className="skills-search">
          <input 
            type="text" 
            placeholder="Search skills, databases, or BI tools (e.g. Power BI, SQL, Python)..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <i className="fas fa-search"></i>
        </div>

        <div className="skills-grid">
          {/* Priority 1: Business Intelligence & Data Visualization */}
          <div className="skill-category featured-category">
            <div className="category-header">
              <h2><i className="fas fa-chart-pie"></i> Business Intelligence & Visualization</h2>
              <span className="category-tag">Core Focus</span>
            </div>
            {renderSkillList(skills.dataAnalyticsBI, 'dataAnalyticsBI')}
          </div>

          {/* Priority 2: SQL & Database Management */}
          <div className="skill-category featured-category">
            <div className="category-header">
              <h2><i className="fas fa-database"></i> SQL & Database Architecture</h2>
              <span className="category-tag">Core Focus</span>
            </div>
            {renderSkillList(skills.databaseSQL, 'databaseSQL')}
          </div>

          {/* Priority 3: Statistical Modeling & Python */}
          <div className="skill-category">
            <div className="category-header">
              <h2><i className="fas fa-brain"></i> Statistical Modeling & Python</h2>
            </div>
            {renderSkillList(skills.mlAi, 'mlAi')}
          </div>

          {/* Priority 4: Commercial Thinking & Analytics */}
          <div className="skill-category">
            <div className="category-header">
              <h2><i className="fas fa-chart-line"></i> Commercial & Business Analytics</h2>
            </div>
            {renderSkillList(skills.analyticalBusiness, 'analyticalBusiness')}
          </div>

          {/* Priority 5: Technical Foundations */}
          <div className="skill-category">
            <div className="category-header">
              <h2><i className="fas fa-code"></i> Programming & Web Integration</h2>
            </div>
            {renderSkillList(skills.technicalProgramming, 'technicalProgramming')}
          </div>

          {/* Priority 6: Stakeholder Communication */}
          <div className="skill-category">
            <div className="category-header">
              <h2><i className="fas fa-comments"></i> Stakeholder & Project Leadership</h2>
            </div>
            {renderSkillList(skills.softSkillsManagement, 'softSkillsManagement')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
